export enum ContentEntityType {
    HeaderText = 'HeaderText',
    Image = 'Image',
    Text = 'Text',
    Video = 'Video',
    MediaObject = 'MediaObject',
    ExternalLink = 'ExternalLink'
}
